// extracted by mini-css-extract-plugin
export default {"wrap":"error-boundary_wrap__y2yvi"};